var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('transition',{attrs:{"name":"fade","appear":""}},[_c('h4',[_vm._v("Title")]),_c('p',[_vm._v("Lorem ipsum dolor sin")])])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"appear":""}},[_c('h4',[_vm._v("Title")]),_c('p',[_vm._v("Lorem ipsum dolor sin")])])
}]

export { render, staticRenderFns }